export default "__VITE_ASSET__eXfwIYLS__"